module.exports = __webpack_public_path__ + "static/main-700-a79050df5f6efbab053f2c7d60c3e70a.png";